"use strict";

var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.set.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.keys.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _default;
  }
});
function _default(pluginConfig, plugins) {
  if (pluginConfig === undefined) {
    return plugins;
  }
  var pluginNames = Array.isArray(pluginConfig) ? pluginConfig : _toConsumableArray(new Set(plugins.filter(function (pluginName) {
    return pluginConfig !== false && pluginConfig[pluginName] !== false;
  }).concat(Object.keys(pluginConfig).filter(function (pluginName) {
    return pluginConfig[pluginName] !== false;
  }))));
  return pluginNames;
}